import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || "es";
  const toggle = () => {
    i18n.changeLanguage(current === "es" ? "en" : "es");
  };

  if (variant === "dark") {
    return (
      <button
        onClick={toggle}
        className="inline-flex items-center gap-1.5 text-xs text-zinc-400 hover:text-white transition-colors"
        aria-label="Switch language"
        data-testid="lang-switcher"
      >
        <Globe size={12} strokeWidth={1.5} />
        {current.toUpperCase()}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className="inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-950 transition-colors"
      aria-label="Switch language"
      data-testid="lang-switcher"
    >
      <Globe size={12} strokeWidth={1.5} />
      {current.toUpperCase()}
    </button>
  );
}
